import { render, staticRenderFns } from "./WBtnActivate.vue?vue&type=template&id=67712a99&scoped=true&"
import script from "./WBtnActivate.vue?vue&type=script&lang=js&"
export * from "./WBtnActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67712a99",
  null
  
)

export default component.exports